import { render, staticRenderFns } from "./zixun.vue?vue&type=template&id=bdb72aea&scoped=true&"
import script from "./zixun.vue?vue&type=script&lang=js&"
export * from "./zixun.vue?vue&type=script&lang=js&"
import style0 from "./zixun.vue?vue&type=style&index=0&id=bdb72aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb72aea",
  null
  
)

export default component.exports